import { Form, Formik } from "formik";
import { v4 as uuidv4 } from "uuid";
import React from "react";
import Input from "../Forms/Inputs/Input";
import Select from "../Forms/Inputs/Select";
import "./ProposalInsuranceSelect.scss";
import * as Yup from "yup";
import { insurances, types } from "../../helper/insuranceOptions";
import { useDispatch } from "react-redux";
import {
  addInsuranceToProposal,
  removingInsurance,
} from "../../actions/proposal";
import { getDateAfter, getDateBefore } from "../../helper/dateConvertor";

const ProposalInsuranceSelect = () => {
  const dispatch = useDispatch();
  const initialValues = {
    provider: "",
    type: "",
    startDate: "",
    endDate: "",
    total: "",
  };

  const dateSixYAfter = getDateAfter();
  const dateDayBefore = getDateBefore(0.15);

  const insuranceSchema = Yup.object().shape({
    provider: Yup.string().required("Select a insurance provider"),
    type: Yup.string().required("Select a type"),
    startDate: Yup.date()
      .required("Select Start Date")
      .max(dateSixYAfter, "Date must be earlier")
      .min(dateDayBefore, "Date must be later"),

    endDate: Yup.date()
      .required("Select End Date")
      .max(dateSixYAfter, "Date must be earlier")
      .min(dateDayBefore, "Date must be later"),
    total: Yup.number().required("Set a total").min(0, "Invalid Number"),
  });

  const handleFormikSubmit = (values) => {
    const inInsurance = uuidv4();
    const insurance = { ...values, _id: inInsurance };

    dispatch(addInsuranceToProposal(insurance));
    dispatch(removingInsurance());
  };

  return (
    <div className="insurance-select-form__container">
      <Formik
        validationSchema={insuranceSchema}
        initialValues={initialValues}
        onSubmit={handleFormikSubmit}
        enableReinitialize
      >
        <div className="insurance-select-form">
          <div className="insurance-form__link">
            <a
              href="https://oshcaustralia.com.au/en"
              target="_blank"
              rel="noreferrer"
              className="link"
            >
              Check Insurance
            </a>
          </div>

          <Form>
            <Select
              name="provider"
              label={`Provider`}
              options={insurances}
              isModal={true}
            />
            <Select name="type" label={`Type`} options={types} isModal={true} />

            <Input
              name="startDate"
              label="Start Date"
              type="date"
              isModal={true}
            />
            <Input name="endDate" label="End Date" type="date" isModal={true} />
            <Input
              name="total"
              label="Price (AUD)"
              type="number"
              isModal={true}
            />
            <div className="insurance-select-form__button">
              <button className="btn-primary" type="submit">
                + add
              </button>
            </div>
          </Form>
        </div>
      </Formik>
    </div>
  );
};

export default ProposalInsuranceSelect;
